import { ReducerInputState } from '@/types/store';
import cartLineItemErrorMessagesReducer, {
  CartLineItemErrorMessages,
} from './cartLineItemErrorMessages';
import { Action } from '../../../actions';

export type CartPage = {
  cartLineItemErrorMessages: CartLineItemErrorMessages;
};

const defaultState = {
  cartLineItemErrorMessages: undefined,
};

export default function cartPageReducer(
  state: ReducerInputState<CartPage> = defaultState,
  action: Action,
): CartPage {
  return {
    cartLineItemErrorMessages: cartLineItemErrorMessagesReducer(
      state.cartLineItemErrorMessages,
      action,
    ),
  };
}
